import { useIsProxySession } from 'src/hooks/useIsProxySession';
import { useAppSelector } from 'src/hooks/useStore';
import { useTrackPageViewMutation } from 'src/services/api/analyticsApi';
import { useRunOncePerNavigation } from 'src/utils/Navigation';

export function AnalyticsTracker() {
  const [trackPageView] = useTrackPageViewMutation();
  const userId = useAppSelector((state) => state.user.id);
  const isProxySession = useIsProxySession(userId);

  useRunOncePerNavigation((routeContext) => {
    if (isProxySession) {
      return;
    }
    const search = new URLSearchParams(routeContext.query).toString();
    // history decodes the route pathname, which turns an encoded '%' in a title
    // slug into a bare one the API rejects; the browser keeps the encoded form.
    const { pathname } = window.location;
    trackPageView({
      eventType: 'PAGE_VIEWED#INC',
      eventData: {
        page: `${pathname}${search ? `?${search}` : ''}`,
      },
    });
  });

  return null;
}
